"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.UnconstrainedWalkThroughSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path fill-rule="evenodd" d="m17.584 2.075 9.88 8.709c.981.885 1.537 2.111 1.536 3.394v14.09c0 1.232-1.058 2.232-2.364 2.232H5.364C4.058 30.5 3 29.5 3 28.267v-14.09c0-1.282.555-2.508 1.536-3.393l9.88-8.709a2.467 2.467 0 0 1 3.168 0Zm2.039 9.93a1 1 0 0 1-.235 1.394l-1.673 1.192C21.865 15.036 25 17.064 25 19.5c0 2.761-4.03 5-9 5s-9-2.239-9-5c0-1.483 1.162-2.814 3.007-3.73.231-.115.474-.223.726-.325a.977.977 0 0 1 .15-.06l.018-.006.031-.011.001.003a1 1 0 0 1 .543 1.924l.002.006a7.708 7.708 0 0 0-.87.412C9.26 18.46 9 19.175 9 19.5c0 .325.26 1.039 1.607 1.787 1.28.71 3.182 1.213 5.393 1.213 2.21 0 4.113-.502 5.393-1.213C22.74 20.54 23 19.825 23 19.5c0-.325-.26-1.039-1.607-1.787-.925-.514-2.177-.92-3.635-1.104l1.63 1.161a1 1 0 1 1-1.16 1.63l-3.069-2.186a2 2 0 0 1 0-3.258l3.07-2.186a1 1 0 0 1 1.394.235Z" clip-rule="evenodd" stroke="none"></path>';
var UnconstrainedWalkThroughSVG = function UnconstrainedWalkThroughSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.UnconstrainedWalkThroughSVG = UnconstrainedWalkThroughSVG;
UnconstrainedWalkThroughSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(UnconstrainedWalkThroughSVG);
exports.default = _default;